import CoreBase from '../../../../services/engines/CoreBase';
import templateLoader from './TemplateLoader';

class ShellInjector extends CoreBase {
    _name = 'ShellInjector';

    /**
     * Loads the HTML shell from the template's htmlRk.
     * @param {object} templateJson - parsed v2 template JSON
     * @returns {string|null} HTML shell string or null
     */
    load(templateJson) {
        if (!templateJson?.htmlRk) {
            this.logError('load: no htmlRk in templateJson');
            return null;
        }

        const note = templateLoader.load(templateJson.htmlRk);
        if (!note) return null;

        return note.body ?? null;
    }
}

const shellInjector = new ShellInjector();
export default shellInjector;
